import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';
import PageSwiper from '@src/components/swiper/page-swiper';
import TopMenu from '@src/business-components/top-menu';
import NegativeSection from './sections/negative-section';
import FirstSection from './sections/first-section';
import SecondSection from './sections/second-section';
// import CreatorsSection from './sections/creators-section';
import ThirdSection from './sections/third-section';
import FourSection from './sections/four-section';
import FiveSection from './sections/five-section';
import SixSection from './sections/six-section';
import SevenSection from './sections/seven-section';
import Footer from './components/footer';
import cx from 'classnames';
import { px2rem } from '@src/utils/rem-util';

const styles = require('./index.less');

const Main = () => {
  const store = useStore(() => new MainStore());
  return (
    <Page>
      <div className={cx(styles.mainRoot, 'page-main')}>
        <TopMenu store={store.topMenuStore} />
        <PageSwiper key={store.isOpenCompetition} store={store.pageSwiperStore}>
          {/* <div className={styles.pageItem} data-name="预热">
            {!store.isFirstLoadNegativeSection && <NegativeSection store={store.negativeSectionStore} />}
          </div> */}
          <div className={styles.pageItem} data-name="首页">
            <FirstSection store={store.firstSectionStore} />
          </div>
          {store.isOpenCompetition && (
            <div className={styles.pageItem} data-name="赛事">
              <SecondSection store={store.secondSectionStore} />
            </div>
          )}
          <div className={styles.pageItem} data-name="游戏特色">
            <ThirdSection store={store.thirdSectionStore} />
          </div>
          <div className={styles.pageItem} data-name="地图">
            <FourSection store={store.fourSectionStore} />
          </div>
          <div className={styles.pageItem} data-name="空投装备">
            <FiveSection store={store.fiveSectionStore} />
          </div>
          <div className={styles.pageItem} data-name="飞行踏板-载具">
            <SixSection store={store.sixSectionStore} />
          </div>
          <div className={styles.pageItem} data-name="敌对目标">
            <SevenSection store={store.sevenSectionStore} />
          </div>
          <div
            className={cx(styles.pageItem, styles.footer)}
            data-name="footer"
            style={{ paddingBottom: `${px2rem(store.vhOffset > 0 ? store.vhOffset : 0)}rem` }}
          >
            <Footer store={store.footerStore} />
          </div>
        </PageSwiper>
      </div>
    </Page>
  );
};

export default observer(Main);
